import React from "react";
import { connect } from "react-redux";

import CaloriesBurnedTabs from "./caloriesBurnedTab";

export const CaloriesBurned = () => {
	return (
		<React.Fragment>
			<h3 className="mt-4">Calories Burned</h3>
			<div className="block block-primary border-0 tab-primary card card-primary w-100 mb-5 px-4">
				<CaloriesBurnedTabs />
			</div>
		</React.Fragment>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(CaloriesBurned);
